<template>
  <div ref="input" class="mdc-text-field mdc-text-field--outlined">
    <input
      @change="onChange"
      :value="value"
      :type="this.type || 'text'"
      class="mdc-text-field__input"
    >
    <div class="mdc-notched-outline">
      <div class="mdc-notched-outline__leading"></div>
      <div class="mdc-notched-outline__notch">
        <label for="tf-outlined" class="mdc-floating-label">{{label}}</label>
      </div>
      <div class="mdc-notched-outline__trailing"></div>
    </div>
  </div>
</template>

<script>
import { MDCTextField } from "@material/textfield";

export default {
  props: ["value", "label", "type"],
  mounted() {
    const textField = new MDCTextField(this.$refs.input);
  },
  methods: {
    onChange(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.mdc-text-field {
  width: 100%;
  padding-top: 5px;
  &.mdc-text-field--focused .mdc-floating-label {
    color: var(--mdc-theme-primary) !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input.vue